import actionTypes from '../actions/game-images.actions';

const initialState = {
  games: [],
  newImages: [],
  isLoading: false,
  isSaving: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GAME_IMAGES_REQUEST:
    case actionTypes.FETCH_GAME_IMAGES_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
        games: [],
      };
    case actionTypes.FETCH_GAME_IMAGES_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        games: [...action.games],
      };
    case actionTypes.UPDATE_GAME_IMAGES:
      const image = state.newImages.find((game) => game.gameId === action.gameImage.gameId);

      if (image) {
        const newImages = state.newImages.map((image) => {
          if (image.gameId === action.gameImage.gameId) {
            return { ...action.gameImage };
          }
          return image;
        });

        return {
          ...state,
          newImages,
        };
      }
      return {
        ...state,
        newImages: [...state.newImages, action.gameImage],
      };
    case actionTypes.CLEAR_GAME_IMAGES:
      return {
        ...state,
        newImages: [],
      };
    case actionTypes.UPDATE_GAME_IMAGES_REQUEST:
    case actionTypes.UPDATE_GAME_IMAGES_FAILURE:
      return {
        ...state,
        isSaving: action.isSaving,
      };
    case actionTypes.UPDATE_GAME_IMAGES_SUCCESS:
      return {
        ...state,
        isSaving: action.isSaving,
        newImages: state.newImages.filter((newImage) => newImage.gameId !== action.game.id),
        games: state.games.map((game) => {
          if (game.id !== action.game.id) {
            return game;
          }
          return {
            ...game,
            imageURL: action.game.imageURL,
          };
        }),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/game-images.reducer.js